import { TextField } from "@material-ui/core";
import { useForm } from "react-hook-form";

import Clock from "react-live-clock";
import TextInputField from "src/components/forms/TextInputField";
const VitalsForm = ({ register, errors }) => {
	return (
		<div className="flex flex-col gap-y-4 relative">
			<div className="flex flex-col lg:flex-row gap-4 ">
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Temperature
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					{...register("temperature", {
						required: true,
					})}
					placeholder="°C"
					InputLabelProps={{ shrink: true }}
					error={errors?.temperature?.message}
					helperText={errors?.temperature && "This field is required"}
				/>
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Pulse
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					placeholder="bpm"
					{...register("pulse", {
						required: true,
					})}
					InputLabelProps={{ shrink: true }}
					error={errors?.pulse?.message}
					helperText={errors?.pulse && "This field is required"}
				/>
			</div>
			<div className="flex flex-col lg:flex-row gap-4 ">
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Systolic Blood Pressure
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					{...register("blood_systolic", {
						required: true,
					})}
					placeholder="Systolic Blood Pressure"
					InputLabelProps={{ shrink: true }}
					error={errors?.blood_systolic?.message}
					helperText={
						errors?.blood_systolic && "This field is required"
					}
				/>
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Diastolic Blood Pressure
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					{...register("blood_diastolic", {
						required: true,
					})}
					placeholder="Diastolic Blood Pressure"
					InputLabelProps={{ shrink: true }}
					error={errors?.blood_diastolic?.message}
					helperText={
						errors?.blood_diastolic && "This field is required"
					}
				/>
			</div>
			<TextInputField
				className="  lg:w-1/2"
				label={
					<>
						Respiratory Rate
						{/* <b className="text-red-500 ml-1">*</b> */}
					</>
				}
				inputClassName="bg-white"
				{...register("respiratory", {
					required: false,
				})}
				placeholder="Breaths per minute"
				InputLabelProps={{ shrink: true }}
				error={errors?.respiratory?.message}
				helperText={errors?.respiratory && "This field is required"}
			/>
			<div className="flex flex-col lg:flex-row gap-4 ">
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Height
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					{...register("height", {
						required: true,
					})}
					placeholder="feet"
					InputLabelProps={{ shrink: true }}
					error={errors?.height?.message}
					helperText={errors?.height && "This field is required"}
				/>
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Weight
							<b className="text-red-500 ml-1">*</b>
						</>
					}
					inputClassName="bg-white"
					{...register("weight", {
						required: true,
					})}
					placeholder="KG"
					InputLabelProps={{ shrink: true }}
					error={errors?.weight?.message}
					helperText={errors?.weight && "This field is required"}
				/>
			</div>
			<div className="flex flex-col lg:flex-row gap-4 ">
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Glucose
							{/* <b className="text-red-500 ml-1">*</b> */}
						</>
					}
					inputClassName="bg-white"
					{...register("glucose", {
						required: false,
					})}
					placeholder="mM"
					InputLabelProps={{ shrink: true }}
					error={errors?.glucose?.message}
					helperText={errors?.glucose && "This field is required"}
				/>
				<TextInputField
					className="  lg:w-1/2"
					label={
						<>
							Uric Acid
							{/* <b className="text-red-500 ml-1">*</b> */}
						</>
					}
					inputClassName="bg-white"
					{...register("uric_acid", {
						required: false,
					})}
					placeholder="mM"
					InputLabelProps={{ shrink: true }}
					error={errors?.glucose?.message}
					helperText={errors?.glucose && "This field is required"}
				/>
			</div>
			<TextInputField
				className="  lg:w-1/2"
				label={
					<>
						Cholesterol
						{/* <b className="text-red-500 ml-1">*</b> */}
					</>
				}
				inputClassName="bg-white"
				{...register("cholesterol", {
					required: false,
				})}
				placeholder="mg/dL"
				InputLabelProps={{ shrink: true }}
				error={errors?.cholesterol?.message}
				helperText={errors?.cholesterol && "This field is required"}
			/>
		</div>
	);
};

export default VitalsForm;
